import React from "react";
import AboutHero from "../components/about/AboutHero";
import StorySection from "../components/about/ourStory/StorySection ";
import StatsSection from "../components/about/ourStory/StatsSection";
import TeamSection from "../pages/Team";
import FloatingHero from "../components/about/FloatingHero";
import FounderSection from "../components/about/FounderSection";

const About = () => {
  return (
    <div>
      <AboutHero />
      <StorySection />
      <StatsSection />
      <FounderSection />
      <TeamSection />
      
    </div>
  );
};

export default About;
